class DevicePixelRatio {
  constructor() {}

  //获取系统类型
  _getSystem() {
    const agent = navigator.userAgent.toLowerCase()
    const isMac = /macintosh|mac os x/i.test(agent)
    const isWin = /windows|win32/i.test(agent)
    if (isMac) {
      return false
    }
    if (isWin) {
      return true
    }
  }

  //监听方法兼容写法
  _addHandler(element, type, handler) {
    element.addEventListener(type, handler, false)
  }

  //校正浏览器缩放比例
  _correct() {
    //页面devicePixelRatio（设备像素比例）变化后，计算页面body标签zoom修改其大小，来抵消devicePixelRatio带来的变化。
    let body = document.getElementById('explain-dialog')
    console.log('body', body)
    body.style.cssText = `zoom: ${1 / window.devicePixelRatio}`
  }

  //监听页面缩放
  _watch() {
    let t = this
    t._addHandler(window, 'resize', () => {
      //注意这个方法是解决全局有两个window.resize
      //重新校正
      t._correct()
    })
  }

  //初始化页面比例
  init() {
    let t = this
    if (t._getSystem()) {
      //判断设备，目前只在windows系统下校正浏览器缩放比例
      //初始化页面校正浏览器缩放比例
      t._correct()
      //开启监听页面缩放
      t._watch()
    }
  }
}

export default DevicePixelRatio
